/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LocationResponse
 */
export interface LocationResponse {
    /**
     * 
     * @type {string}
     * @memberof LocationResponse
     */
    locationType: LocationResponseLocationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof LocationResponse
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationResponse
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationResponse
     */
    countryCode?: string;
}


/**
 * @export
 */
export const LocationResponseLocationTypeEnum = {
    Everywhere: 'EVERYWHERE',
    Exact: 'EXACT',
    Near: 'NEAR',
    Remote: 'REMOTE',
    SearchLocationFarFromHome: 'SEARCH_LOCATION_FAR_FROM_HOME'
} as const;
export type LocationResponseLocationTypeEnum = typeof LocationResponseLocationTypeEnum[keyof typeof LocationResponseLocationTypeEnum];


/**
 * Check if a given object implements the LocationResponse interface.
 */
export function instanceOfLocationResponse(value: object): value is LocationResponse {
    if (!('locationType' in value) || value['locationType'] === undefined) return false;
    return true;
}

export function LocationResponseFromJSON(json: any): LocationResponse {
    return LocationResponseFromJSONTyped(json, false);
}

export function LocationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'locationType': json['locationType'],
        'city': json['city'] == null ? undefined : json['city'],
        'country': json['country'] == null ? undefined : json['country'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
    };
}

export function LocationResponseToJSON(value?: LocationResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'locationType': value['locationType'],
        'city': value['city'],
        'country': value['country'],
        'countryCode': value['countryCode'],
    };
}

